/**
 * @typedef {import('../libraries/packages/rai-bdo/src/index').PolicyManager} PolicyManager
 */

export function getValueFromJson(keys, json) {
  if (!Array.isArray(keys)) {
    keys = keys.split(".");
  }

  function getKeyVal(obj, key) {
    const k = parseInt(key, 10);
    if (k.toString() === key) {
      key = k;
    }

    if (Array.isArray(obj)) {
      return typeof key === "number" && obj.length > key ? obj[key] : null;
    }

    return (obj?.[key] ?? null);
  }

  const val = keys.reduce(getKeyVal, json);
  return val;
}

export function replaceSpecialCharacters(val) {
  return val
    .replace(/%C3%A0/g, "a")
    .replace(/%C3%80/g, "A")
    .replace(/%C3%A8/g, "e")
    .replace(/%C3%88/g, "E")
    .replace(/%C3%AC/g, "i")
    .replace(/%C3%8C/g, "I")
    .replace(/%C3%B2/g, "o")
    .replace(/%C3%92/g, "O")
    .replace(/%C3%B9/g, "u")
    .replace(/%C3%99/g, "U");
}

export function getMetaValue(name) {
  if (!name) {
    return false;
  }

  let res = false;
  const meta = document.querySelector("meta[property=" + name + "]");
  res = (!!meta && meta.content) || false;
  return res;
}

export function get_video_duration(hms) {
  if (!hms) {return null;}
  const a = hms.split(":");
  const minutes = a.length > 1 ? (+a[0] * 60) + +a[1] : a[0];
  return minutes + " min";
}

export function adUnitIframeOverride(videoItemJson) {
  let override = false;
  if (document.referrer.indexOf("msn.com") > -1) {
    switch (location.host.replace(/www.|.com|.it/g, "")) {
    case "raiplay":
      override = "/rmsnw/progr/spett/video";
      break;
    case "rainews":
      override = "/rmsnw/progr/newsx/video";
      break;
    case "raisport":
      override = "/rmsnw/progr/sport/video";
      break;
    default:
      break;
    }

    if (videoItemJson.typology === "programmi tv" || videoItemJson.typology === "fiction") {
      override = "/rmsnw/progr/spett/video";
    }

    if (videoItemJson.program_info.name.toLowerCase().indexOf("sanremo") >= 0) {
      override = "/rmsnw/progr/sanrm/video";
    }

    if (videoItemJson.program_info.name.toLowerCase().indexOf("altro festival") >= 0) {
      override = "/rmsnw/progr/sanrm/video";
    }

    if (videoItemJson.program_info.name.toLowerCase().indexOf("vivaraiplay") >= 0) {
      override = "/rmsnw/progr/vivar/video";
    }
  }

  return override;
}

export function getStringOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return "android";
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "ios";
  }

  return "web";
}

export function setupMsnPostMessages(raiPlayer) {
  const objToSend = {};
  objToSend.referrer = "microsoft";
  objToSend.event = "load";
  parent.postMessage(objToSend, document.referrer);
  raiPlayer.on(raiPlayer.events.EventsType.CREATION, () => {
    objToSend.event = "load";
    parent.postMessage(objToSend, document.referrer);
  });
  raiPlayer.on(raiPlayer.events.EventsType.FIRSTPLAY, () => {
    objToSend.event = "start";
    objToSend.videoType = "content";
    parent.postMessage(objToSend, document.referrer);
  });
  raiPlayer.on(raiPlayer.events.EventsType.ENDED, () => {
    objToSend.event = "end";
    objToSend.videoType = "content";
    parent.postMessage(objToSend, document.referrer);
  });
}

export function isInIframe() {
  return top !== self;
}

export function isIframePage() {
  return document.body.classList.contains("iframe");
}

export function isInMsnIframe() {
  return isIframePage() && document.referrer.indexOf("msn.com") >= 0;
}

export function isEmbeddableForm(videoItemJson) {
  const form = videoItemJson.form.toLowerCase();
  return form === "clip" || form === "extra" || videoItemJson.is_live;
}

export function isEmbeddableContent(videoItemJson) {
  try {
    const programName
      = !!videoItemJson.program_info && !!videoItemJson.program_info.name ? videoItemJson.program_info.name.toLowerCase() : "";
    if (
      programName.indexOf("sanremo") >= 0
      || programName.indexOf("altro festival") >= 0
      || programName.indexOf("L'AltroFestival") >= 0
      || programName.indexOf("l'altrofestival") >= 0
    ) {
      return isEmbeddableForm(videoItemJson);
    }

    console.log("not embeddable");
    return false;
  } catch (e) {
    console.log("not embeddable catch");
    console.log(e);
    return false;
  }
}

export function isHomepage() {
  return document.body.classList.contains("rai-home");
}

export function getAdvLabelFromPage() {
  if (!!window.rai_adv && !!window.rai_adv.adv_label) {return window.rai_adv.adv_label;}
  if (!!window.rai_adv && !!window.rai_adv.dfp && !!window.rai_adv.dfp.label) {return window.rai_adv.dfp.label;}
  if (isHomepage()) {return "hompg/hompg";}
  if (isNativePage()) {return "hompg/hompg";}
  if (document.body.classList.contains("my-list-page")) {return "progr/lmlst";}
  return "rplyw/genrc";
}

export function isNativePage() {
  return document.body.classList.contains("rai-native");
}

export function getAdvPortalCode() {
  const domain = document.domain.indexOf("www.") > -1 ? document.domain.split(".")[1] : document.domain.split(".")[0];
  let portalCode = "rplyw";
  switch (domain) {
  case "raiplay":
    portalCode = "rplyw";
    break;
  case "rainews":
  case "rainews-dev":
  case "rainews-pre":
  case "rainews-int":
    portalCode = "rnwsw";
    break;
  case "rai":
    if (isInIframe() && document.referrer.indexOf("msn.com") > -1) {
      portalCode = "rplyw";
    } else {
      window.raiAdv.dfp.codicePortale = "raitw";
    }

    break;
  case "raisport":
    portalCode = "rsptw";
    break;
  default:
    break;
  }

  return portalCode;
}

export function getUrlParameter(sParam) {
  const sPageURL = window.location.search.substring(1);
  const sURLVariables = sPageURL.split("&");
  let sParameterName;
  let i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }

  return null;
}

export function generatePassword(length, prefix) {
  if (typeof length !== "number") {length = 8;}
  if (typeof prefix !== "string") {prefix = "";}
  const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@_$!*";
  let retVal = prefix;
  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }

  return retVal;
}

export async function getGDPRManager() {
  if (window.Rai?.PolicyManager) {
    return window.Rai.PolicyManager;
  }

  return new Promise(resolve => {
    window.Rai = new Proxy(window.Rai ?? {}, {
      set(target, prop, val) {
        const setted = Reflect.set(target, prop, val);
        if (prop === "PolicyManager") {
          setTimeout(() => {
            resolve(window.Rai.PolicyManager);
          });
        }

        return setted;
      },
    });
  });
}

export async function getPrivacyConsent() {
  const GDPRManager = await getGDPRManager();
  return new Promise(resolve => {
    GDPRManager.events$.subscribe(event => {
      if (event.type === GDPRManager.events.POLICY_MANAGER_DEFINED_EVENT) {
        const _manager = window.Rai.PolicyManager;
        resolve(_manager.hasOptIn());
      }
    });
  });
}

export async function getAdvPrivacyConsent() {
  const GDPRManager = await getGDPRManager();
  return new Promise(resolve => {
    GDPRManager.events$.subscribe(event => {
      if (event.type === GDPRManager.events.POLICY_MANAGER_DEFINED_EVENT) {
        const _manager = window.Rai.PolicyManager;
        resolve(_manager.hasGoogleVendorAvailable() && _manager.hasAdvConsents());
      }
    });
  });
}

export async function getTcString() {
  const GDPRManager = await getGDPRManager();
  return new Promise(resolve => {
    GDPRManager.events$.subscribe(event => {
      if (event.type === GDPRManager.events.POLICY_MANAGER_DEFINED_EVENT) {
        const _manager = window.Rai.PolicyManager;
        resolve(_manager.getTcString());
      }
    });
  });
}

export async function getCustomPurposesConsents() {
  const GDPRManager = await getGDPRManager();
  return new Promise(resolve => {
      GDPRManager.events$.subscribe(event => {
          if (event.type === GDPRManager.events.POLICY_MANAGER_DEFINED_EVENT) {
              const _manager = window.Rai.PolicyManager;
              resolve(_manager.getCustomPurposesConsents());
          }
      });
  });
}


export async function getCrossDomainManager() {
  return new Promise(resolve => {
      if (window.Rai?.CrossDomainManager) {
          resolve(window.Rai.CrossDomainManager);
      } else {
        const origObj = window.Rai ?? {};
        window.Rai = new Proxy(origObj, {
            set(target, prop, value) {
            const setted = Reflect.set(target, prop, value);
            if (prop === 'CrossDomainManager') {
                window.Rai = origObj;
                window.setTimeout(() => resolve(window.Rai.CrossDomainManager), 0);
            }
            return setted;
            }
        });
      }
  })
}

export const escapeHTML = str =>
  str.replace(
    /[&<>'"]/g,
    tag =>
      ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        "'": "&#39;",
        '"': "&quot;",
      }[tag] || tag),
  );

export const chunk = (arr, chunkSize = 1, cache = []) => {
  const tmp = [...arr];
  if (chunkSize <= 0) {return cache;}
  while (tmp.length) {cache.push(tmp.splice(0, chunkSize));}
  return cache;
};

export function getScript(url, callback) {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;
  // Most browsers
  if (typeof callback === "function") {
    script.onload = callback;
    // IE 6 & 7
    script.onreadystatechange = function () {
      if (this.readyState === "complete") {
        try {
          callback();
        } catch (e) {
          console.error(e);
        }
      }
    };
  }

  document.getElementsByTagName("head")[0].appendChild(script);
}

export function getChanInfo(chan, key) {
  const chanInfo = {
    "Rai 1": {
      path_id: "/dirette/rai1.json",
      weblink: "/dirette/rai1",
      class: "rai-1",
    },
    "Rai 2": {
      path_id: "/dirette/rai2.json",
      weblink: "/dirette/rai2",
      class: "rai-2",
    },
    "Rai 3": {
      path_id: "/dirette/rai3.json",
      weblink: "/dirette/rai3",
      class: "rai-3",
    },
    "Rai 4": {
      path_id: "/dirette/rai4.json",
      weblink: "/dirette/rai4",
      class: "rai-4",
    },
    "Rai 5": {
      path_id: "/dirette/rai5.json",
      weblink: "/dirette/rai5",
      class: "rai-5",
    },
    "Rai Movie": {
      path_id: "/dirette/raimovie.json",
      weblink: "/dirette/raimovie",
      class: "rai-movie",
    },
    "Rai Premium": {
      path_id: "/dirette/raipremium.json",
      weblink: "/dirette/raipremium",
      class: "rai-premium",
    },
    "Rai Gulp": {
      path_id: "/dirette/raigulp.json",
      weblink: "/dirette/raigulp",
      class: "rai-gulp",
    },
    "Rai Yoyo": {
      path_id: "/dirette/raiyoyo.json",
      weblink: "/dirette/raiyoyo",
      class: "rai-yoyo",
    },
    "Rai Storia": {
      path_id: "/dirette/raistoria.json",
      weblink: "/dirette/raistoria",
      class: "rai-storia",
    },
    "Rai Scuola": {
      path_id: "/dirette/raiscuola.json",
      weblink: "/dirette/raiscuola",
      class: "rai-scuola",
    },
    "Rai News 24": {
      path_id: "/dirette/rainews24.json",
      weblink: "/dirette/rainews24",
      class: "rainews",
    },
    "Rai Sport piu HD": {
      path_id: "/dirette/raisportpiuhd.json",
      weblink: "/dirette/raisportpiuhd",
      class: "raisport--hd",
    },
    "Rai Sport": {
      path_id: "/dirette/raisport.json",
      weblink: "/dirette/raisport",
      class: "raisport-2",
    },
    "Rai Sport HD": {
      path_id: "/dirette/raisporthd.json",
      weblink: "/dirette/raisporthd",
      class: "raisporthd",
    },
    Raiplay: {
      path_id: "/dirette/raiplay.json",
      weblink: "/dirette/raiplay",
      class: "raiplay",
    },
    RaiPlay: {
      path_id: "/dirette/raiplay.json",
      weblink: "/dirette/raiplay",
      class: "raiplay",
    },
    "Raiplay 2": {
      path_id: "/dirette/raiplay2.json",
      weblink: "/dirette/raiplay2",
      class: "raiplay2",
    },
    Raiplay2: {
      path_id: "/dirette/raiplay2.json",
      weblink: "/dirette/raiplay2",
      class: "raiplay2",
    },
    "RaiPlay 2": {
      path_id: "/dirette/raiplay2.json",
      weblink: "/dirette/raiplay2",
      class: "raiplay2",
    },
    RaiPlay2: {
      path_id: "/dirette/raiplay2.json",
      weblink: "/dirette/raiplay2",
      class: "raiplay2",
    },
    "RaiPlay 3": {
      path_id: "/dirette/raiplay3.json",
      weblink: "/dirette/raiplay3",
      class: "raiplay3",
    },
    RaiPlay3: {
      path_id: "/dirette/raiplay3.json",
      weblink: "/dirette/raiplay3",
      class: "raiplay3",
    },
    "Raiplay Sport 2": {
      path_id: "/dirette/raiplaysport2.json",
      weblink: "/dirette/raiplaysport2",
      class: "raiplaysport2",
    },
    "Raiplay Sport": {
      path_id: "/dirette/raiplaysport.json",
      weblink: "/dirette/raiplaysport",
      class: "raiplaysport",
    },
    "Rai Radio 2": {
      path_id: "/dirette/rairadio2.json",
      weblink: "/dirette/rairadio2",
      class: "rairadio2",
    },
  };
  if (!!chanInfo[chan] && !!chanInfo[chan][key]) {
    return chanInfo[chan][key];
  }

  return "";
}

export function setRaiGlobalProperty(key, value) {
  if (typeof key !== "string") {return;}
  window.Rai = window.Rai || {};
  window.Rai[key] = value;
  return value;
}

export function getRaiGlobalProperty(key) {
  if (typeof key !== "string") {return null;}
  return window.Rai ? window.Rai[key] : null;
}

export async function waitRaiGlobalProperty(varName, needTimeout, timeout) {
  if (window.Rai?.[varName]) {
    return window.Rai[varName];
  }

  return new Promise(resolve => {
    let tmt;
    window.Rai = new Proxy(window.Rai ?? {}, {
      set(target, prop, value) {
        const setted = Reflect.set(target, prop, value);
        if (prop === varName) {
          window.clearTimeout(tmt);
          window.setTimeout(() => {
            resolve(window.Rai[varName]);
          }, 0);
        }

        return setted;
      },
    });
    if (needTimeout) {
      tmt = window.setTimeout(() => {
        resolve(undefined);
      }, timeout || 1000);
    }
  });
}
